import { Box, Button, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function TrialSetupComplete() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/channels');
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Box
        className="animate__animated animate__fadeIn"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src="/images/oppies/Oppy_Expressions_smiling.svg"
          alt="Stripe card verification done"
          width={200}
          height={200}
        />
        <Typography variant="h4" mt={2}>
          Stripe card verification done 🎉
        </Typography>
        <Typography variant="body1" mt={2} textAlign="center" maxWidth="500px">
          You can now start using our platform. If the page doesn't load
          automatically, click the button below.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
          onClick={() => {
            navigate('/channels');
          }}
        >
          Go to dashboard
        </Button>
      </Box>
    </Box>
  );
}
